// **  Initial State
const initialState = {
	data: {
		asset_types: []
	},
	loading: false
}

export const assetReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_ASSET_TYPES_LIST':
			const editState = _.cloneDeep(state)
			editState.data.asset_types = action.payload
			return editState
		default:
			return state
	}
}
